import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Form, Input, Button, Breadcrumb, message } from "antd";
import { accountSchema } from "../../components/validations/accountManagerValidation";
import BackButton from "../../components/reuseComp/BackButton";
import {
  useAccountantDetail,
  UseAccountantSave,
} from "../../../hooks/api/accountant/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

export default function AccountantForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: detail, isLoading } = useAccountantDetail(id ?? "");

  const { mutate: saveAccountant } = UseAccountantSave({
    onSuccess: (res) => {
      message.success("Accountant saved successfully");
      navigate("/accountant");
    },
    onError: (error) => {
    },
  });



  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(accountSchema),
  });

  useEffect(() => {
    if (detail?.data?._id) {
      reset({
        name: detail?.data?.name,
        designation: detail?.data?.designation,
        email: detail?.data?.email,
        phone: detail?.data?.phone,
        experience: detail?.data?.experience,
      });
    }
  }, [detail]);

  const onSubmit = (data: any) => {
    let payload = { ...data };
    if (id) {
      payload._id = id;
    }

    saveAccountant(payload);
  };

  return (
    <div>
      <div className="mb-6">
        <div>
          <BackButton>Back</BackButton>
        </div>
        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">
          {id ? "Update Accountant" : "Create Accountant"}
        </h1>
        <div className="mb-4">
          <Breadcrumb
            separator=">"
            items={[{ title: "Dashboard" }, { title: "Accountant" }]}
            className="text-xs sm:text-base"
          />
        </div>
      </div>

      <div className="">
        <Form layout="vertical" onFinish={handleSubmit(onSubmit)} className="">
          {/* Name */}

          <div className="bg-[#FEF2E7] p-4 rounded-xl grid md:grid-cols-2 gap-4">
            <Form.Item
              label="Name"
              validateStatus={errors.name ? "error" : ""}
              help={errors.name?.message}
            >
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <Input className="" {...field} placeholder="Enter name" />
                )}
              />
            </Form.Item>

            <Form.Item
              label="Designation"
              validateStatus={errors.designation ? "error" : ""}
              help={errors.designation?.message}
            >
              <Controller
                name="designation"
                control={control}
                render={({ field }) => (
                  <Input
                    className=""
                    {...field}
                    placeholder="Enter designation"
                  />
                )}
              />
            </Form.Item>

            {/* Email */}
            <Form.Item
              label="Email"
              validateStatus={errors.email ? "error" : ""}
              help={errors.email?.message}
            >
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <Input className="" {...field} placeholder="Enter email" />
                )}
              />
            </Form.Item>

            {/* Phone */}
            <Form.Item
              label="Phone"
              validateStatus={errors.phone ? "error" : ""}
              help={errors.phone?.message}
            >
              <Controller
                name="phone"
                control={control}
                render={({ field }) => (
                  <Input
                    className=""
                    type="number"
                    {...field}
                    placeholder="Enter phone"
                  />
                )}
              />
            </Form.Item>

            <Form.Item
              label="Experience"
              validateStatus={errors.experience ? "error" : ""}
              help={errors.experience?.message}
            >
              <Controller
                name="experience"
                control={control}
                render={({ field }) => (
                  <Input
                    className=""
                    type="number"
                    {...field}
                    placeholder="Enter experience"
                  />
                )}
              />
            </Form.Item>
          </div>

          <div className="p-4">
            <Button
              type="primary"
              htmlType="submit"
              className="bg-primary h-[35px] w-[160px]"
            >
              {id ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
